import React from "react";
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Skeleton,
} from "@chakra-ui/react";

export function InvestmentAccreditationSkeleton(): React.JSX.Element {
  return (
    <VStack justify="flex-start" align="start" gap={4} flex={2}>
      <Card w="full">
        <CardBody>
          <Skeleton height="24px" width="200px" mb={4} />
          
          <HStack spacing={4} mb={6}>
            <Skeleton height="24px" width="24px" />
            <Skeleton height="20px" width="100px" />
            <Skeleton height="20px" width="80px" />
          </HStack>

          <HStack spacing={4}>
            <Skeleton height="40px" width="180px" />
            <Skeleton height="40px" width="160px" />
          </HStack>
        </CardBody>
      </Card>

      {/* Accreditation Verification Card */}
      <Card w="full">
        <CardBody>
          <Skeleton height="24px" width="220px" mb={4} />
          
          <VStack align="stretch" spacing={4}>
            {/* File rows */}
            {[1, 2].map((i) => (
              <HStack key={i} justify="space-between">
                <Skeleton height="20px" width="200px" />
                <HStack spacing={4}>
                  <Skeleton height="20px" width="80px" />
                  <Skeleton height="20px" width="100px" />
                </HStack>
              </HStack>
            ))}

            {/* Upload area */}
            <Skeleton height="100px" />
          </VStack>
        </CardBody>
      </Card>

      {/* Address Verification Card */}
      <Card w="full">
        <CardBody>
          <Skeleton height="24px" width="180px" mb={4} />
          
          {/* Upload area */}
          <Skeleton height="100px" />
        </CardBody>
      </Card>
    </VStack>
  );
} 